import apollo from '@/apollo.js'
import gql from 'graphql-tag'
import { asGraphQLString } from '@/provider/graphqlStrings.js'

const scriptMutationVariables = (data) => {
  return {
    name: asGraphQLString(data.name),
    description: asGraphQLString(data.description),
    draftCode: asGraphQLString(data.draftCode),
    publishedCode: asGraphQLString(data.publishedCode),
    draftDocument: asGraphQLString(data.draftDocument),
    reusable: !!data.reusable,
    isMicroservice: !!data.isMicroservice,
    runtimeType: data.runtimeType != null ? data.runtimeType : undefined,
    runtimeLanguage: data.runtimeLanguage != null ? data.runtimeLanguage : undefined,
    runtimeImage: data.runtimeImage != null ? data.runtimeImage : null
  }
}

const SCRIPT_FIELDS = `
  id
  name
  description
  createdAt
  updatedAt
  draftCode
  publishedCode
  draftDocument
  reusable
  isMicroservice
  runtimeType
  runtimeLanguage
  runtimeImage
  error
  message
  lowLevelErrorMessage
`

export const createScript = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation createScript($caseTypeId: Int!, $name: String!, $description: String!,
         $draftCode: String!, $publishedCode: String!, $draftDocument: String!, $reusable: Boolean!, $isMicroservice: Boolean!,
         $runtimeType: String, $runtimeLanguage: String, $runtimeImage: String) {
        createScript(caseTypeId: $caseTypeId, name: $name, description: $description, draftCode: $draftCode, publishedCode: $publishedCode, draftDocument: $draftDocument, reusable: $reusable, isMicroservice: $isMicroservice, runtimeType: $runtimeType, runtimeLanguage: $runtimeLanguage, runtimeImage: $runtimeImage ) {
          ${SCRIPT_FIELDS}
        }
      }`),
      variables: Object.assign(scriptMutationVariables(data), {
        caseTypeId: data.caseTypeId,
        runtimeType: data.runtimeType != null ? data.runtimeType : 'faas',
        runtimeLanguage: data.runtimeLanguage != null ? data.runtimeLanguage : 'javascript'
      })
    }
  )
  return response.data.createScript
}

export const updateScript = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation updateScript($id: Int!, $name: String!, $description: String!,
         $draftCode: String!, $publishedCode: String!, $draftDocument: String!, $reusable: Boolean!, $isMicroservice: Boolean!,
         $runtimeType: String, $runtimeLanguage: String, $runtimeImage: String) {
          updateScript(id: $id, name: $name, description: $description, draftCode: $draftCode, publishedCode: $publishedCode, draftDocument: $draftDocument, reusable: $reusable, isMicroservice: $isMicroservice, runtimeType: $runtimeType, runtimeLanguage: $runtimeLanguage, runtimeImage: $runtimeImage ) {
            ${SCRIPT_FIELDS}
          }
      }`),
      variables: Object.assign(scriptMutationVariables(data), {
        id: data.id
      })
    }
  )
  return response.data.updateScript
}

export const executeScript = async (data) => {
  const executePublished = !!data.executePublished
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation executeScript($id: Int!, $payload: JSON!, $executePublished: Boolean, $runId: String) {
        executeScript(id: $id, payload: $payload, executePublished: $executePublished, runId: $runId) {
          runId
          error
          message
          lowLevelErrorMessage
          failureMessage
          status
          responseTime
          meta
          log { message level timestamp }
          output
        }
      }
      `),
      variables: { id: data.id, payload: data.payload, executePublished, runId: data.runId || null }
    }
  )
  return response.data.executeScript
}

export const getScriptExecutionPhase = async (runId) => {
  const response = await apollo.query({
    query: gql(`
      query scriptExecutionPhase($runId: String!) {
        scriptExecutionPhase(runId: $runId) {
          runId
          phase
          log { message level timestamp }
          output
          status
          responseTime
          meta
          failureMessage
          message
          error
        }
      }
    `),
    variables: { runId },
    fetchPolicy: 'network-only',
  })
  return response.data.scriptExecutionPhase
}

export const deleteScript = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteScript($id: Int!) {
        deleteScript(id: $id) { error message lowLevelErrorMessage }
      }`),
      variables: { id: id }
    }
  )
  return response.data.deleteScript
}
